/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { CarePlanFollowUp } from "./CarePlanFollowUp";
import type { CarePlanLabOrder } from "./CarePlanLabOrder";
import type { CarePlanMedication } from "./CarePlanMedication";

/**
 * A care plan in the user's care hub, including its source event.
 */
export interface CarePlanListItem {
  diagnosis: string;
  created: string;
  medications?: CarePlanMedication[] | null;
  lab_orders?: CarePlanLabOrder[] | null;
  recommendations?: string[] | null;
  follow_up?: CarePlanFollowUp | null;
  sender_full_name_with_title: string | null;
  id: string;
  conversation_id: string;
}
